import {
  IMedicationInquiry,
  IMedicationResponse,
  IMedicationShareResponseDetails,
} from '@interfaces/medications';
import { TInquiriesListKey } from '@store/features/inquiries/list/slice.interface';

import { IFetchListRequestPayload, IIdentity, ITableData } from './common';
import { ISupplementInquiry, ISupplementResponse, ISupplementResponseDetails } from './supplements';

export enum TInquiryStatus {
  None = 1,
  Draft,
  Pending,
  NeedsInfo,
  Complete,
  New,
}

export interface IInquiryDetails extends IIdentity {
  inquiryStatusId: TInquiryStatus;
  createdOn: string;
  supplementInquiriesDto: ISupplementInquiry[];
  medicationInquiriesDto: IMedicationInquiry[];
}

export type IInquiriesTableData = ITableData<IInquiryDetails>;

export interface ICreateInquiry extends IIdentity {
  createdOn?: string;
  inquiryStatusId: TInquiryStatus;
  supplementInquiriesDto: ISupplementInquiry[];
  medicationInquiriesDto: IMedicationInquiry[];
}

export interface IInquiryResponse extends IIdentity {
  createdOn: string;
  submittedOn: string;
  inquiryStatusId: TInquiryStatus;
  supplementInquiriesDto: ISupplementResponse[];
  medicationInquiriesDto: IMedicationResponse[];
}

export interface IInquiriesSearchProps {
  key: TInquiriesListKey;
  search?: string;
  isComplete: boolean;
  page: number;
}

export interface IInquiriesSearchPayload {
  isCompleted: boolean;
  pagedResultsRequest: IFetchListRequestPayload;
}

export interface ICreateInquiryPayload {
  supplementId: number | null;
  userEnteredSupplementId: number | null;
  inquiryName?: string;
}

export interface IAddSupplementToInquiryPayload {
  inquiryId: number;
  supplementId: number | null;
  userEnteredSupplementId: number | null;
}

export interface ISubmitInquiryProps {
  inquiryId: number;
  inquiryName?: string;
}

export interface ISubmitInquiryPayload {
  id: number;
  inquiryName?: string;
}

export interface IPrintInquiryResponse extends IIdentity {
  submittedDate: string;
  programCodeId: number;
  inquiryResponseDetailsDtos: ISupplementResponseDetails[];
  medicationInquiryResponseDetailsDtos: IMedicationShareResponseDetails[];
}

export interface IShareInquiryResponsePayload {
  inquiryId: number;
  supplementInquiriesIds?: number[];
  medicationInquiriesIds?: number[];
}

export interface IShareInquiryResponseResult {
  sharedInquiryUrl: string;
}

export interface ISharedInquiryResponse extends IIdentity {
  submittedDate: string;
  programCodeId: number;
  inquiryResponseDetailsDtos: ISupplementResponseDetails[];
  medicationInquiryResponseDetailsDtos: IMedicationShareResponseDetails[];
}

export interface ICreateInquiryMedicationPayload {
  userEnteredMedicationId: number | null;
  inquiryName?: string;
}

export interface IAddMedicationToInquiryPayload {
  inquiryId: number;
  userEnteredMedicationId: number | null;
}

export enum InquiryEntryType {
  Medication = 'medication',
  Supplement = 'supplement',
}
